import { ItemDaTabelaDePreco } from '@/models';
import {Inject} from "inversify-props";
import type { TabelaDePrecoServiceAdapter } from './adapter/TabelaDePrecoServiceAdapter';

export class AdicionarItensEmLoteUseCase {
	@Inject('TabelaDePrecoServiceAdapter')
	private tabelaService!: TabelaDePrecoServiceAdapter

	async adicionarItensEmLote(idTabela: string, itens: ItemDaTabelaDePreco[]): Promise<ItemDaTabelaDePreco[]> {
		return this.tabelaService.adicionarItensEmLote(idTabela, itens)
	}
}
